import { animate, style, transition, trigger } from '@angular/animations';
import { Component, ChangeDetectionStrategy } from '@angular/core';
import { ProgressSpinner } from 'primeng/progressspinner';

@Component({
  selector: 'd2d-loader',
  imports: [ProgressSpinner],
  template: `
    <div
      [@fadeOutAnimation]
      class="w-full min-h-screen fixed inset-0 z-[9999] bg-white/80 dark:bg-gray-900/80 backdrop-blur-sm flex items-center justify-center"
    >
      <p-progress-spinner
        ariaLabel="loading"
        [style]="{ width: '4rem', height: '4rem' }"
        strokeWidth="4"
      />
    </div>
  `,
  changeDetection: ChangeDetectionStrategy.Eager,
  animations: [
    trigger('fadeOutAnimation', [
      transition(':leave', [animate('300ms ease-in', style({ opacity: 0 }))]),
      transition(':enter', [
        style({ opacity: 0 }),
        animate('300ms ease-out', style({ opacity: 1 })),
      ]),
    ]),
  ],
})
export class LoaderComponent {}
